import React, { useEffect, useCallback } from 'react';
import { useTranslation } from "../context/TranslationContext";
import { useWebSocket } from '../context/WebSocketContext';
import { useNavigate } from "react-router-dom";
import { ConnectionEventEmitter } from '../utils/ConnectionEventEmitter';
import log from "loglevel";

import PanelMain from '../components/PanelMain';
import HostPanel from "../components/HostPanel";
import '../styles/Host.css'; 

import { ReactComponent as Logo } from "../resources/assets/logoHorizontal.svg"; 
import { ReactComponent as MainAttractions } from "../resources/assets/mainAttractions.svg";
import { ReactComponent as MainCalendar } from "../resources/assets/mainCalendar.svg";
import { ReactComponent as MainDishes } from "../resources/assets/mainDishes.svg";
import { ReactComponent as MainFinance } from "../resources/assets/mainFinance.svg";
import { ReactComponent as MainGuests } from "../resources/assets/mainGuests.svg";
import { ReactComponent as MainProperties } from "../resources/assets/mainProperties.svg";
import { ReactComponent as MainPlaces } from "../resources/assets/mainPlaces.svg";
import { ReactComponent as MainRestaurants } from "../resources/assets/mainRestaurants.svg";
import { ReactComponent as MainOffers } from "../resources/assets/mainOffers.svg";
import { ReactComponent as MainReservations } from "../resources/assets/mainReservations.svg";
import { ReactComponent as MainMarketing } from "../resources/assets/mainMarketing.svg";
import { ReactComponent as MainStatistics } from "../resources/assets/mainStatistics.svg";

function Host() {
  const { t } = useTranslation();
  const { sendMessage, isConnected } = useWebSocket();
  const navigate = useNavigate();

  const items = [
    { icon: MainPlaces, label: t.host.Places, navigate: "places"},
    { icon: MainAttractions, label: t.host.Attractions, navigate: "attractions"},
    { icon: MainDishes, label: t.host.Dishes, navigate: "dishes"},
    { icon: MainRestaurants, label: t.host.Restaurants, navigate: "restaurants"},
    { icon: MainProperties, label: t.host.Properties, navigate: ""},
    { icon: MainGuests, label: t.host.Guests, navigate: ""},
    { icon: MainOffers, label: t.host.Offers, navigate: ""},
    { icon: MainReservations, label: t.host.Reservations, navigate: ""},
    { icon: MainMarketing, label: t.host.Marketing, navigate: ""},
    { icon: MainStatistics, label: t.host.Statistics, navigate: ""},
    { icon: MainFinance, label: t.host.Finance, navigate: ""},
    { icon: MainCalendar, label: t.host.Calendar, navigate: ""}
  ];
  
  const connectionOpened = useCallback(() => {
    log.debug('Host connectionOpened');
  }, []);

  const connectionClosed = useCallback(() => {
    log.debug('Host connectionClosed');
  }, []);

  const connectionReceived = useCallback((receivedMessage) => {
    if(receivedMessage) {
      log.debug('Host message:', receivedMessage);
    }
  }, []);

  useEffect(() => {    
    ConnectionEventEmitter.on('opened', connectionOpened);
    ConnectionEventEmitter.on('closed', connectionClosed);
    ConnectionEventEmitter.on('received', connectionReceived);
    return () => { 
      ConnectionEventEmitter.off('opened', connectionOpened);
      ConnectionEventEmitter.off('closed', connectionClosed);
      ConnectionEventEmitter.off('received', connectionReceived);
    }
  }, []);

  return (
    <PanelMain className="host-main">
        <Logo className="host-logo" />
        <HostPanel items={items} />
    </PanelMain>
  );
}

export default Host;